import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const AuthContext = createContext();
export { AuthContext }; // <-- LIPSEA!

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

const checkAuth = async () => {
  setLoading(true);
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/user`, {
      withCredentials: true,
      timeout: 5000
    });
    const userData = res.data;
    setUser(userData);

    // 👇 Aplică tema global (fără context circular)
    if (typeof userData.dark_mode === 'boolean') {
      if (userData.dark_mode) {
        document.documentElement.classList.add('dark-mode');
      } else {
        document.documentElement.classList.remove('dark-mode');
      }
    }

  } catch (err) {
    console.log('Auth check failed:', err.message);
    setUser(null);
    document.documentElement.classList.remove('dark-mode'); // fallback safe
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    checkAuth();
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, checkAuth, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
